module.exports = __webpack_public_path__ + "static/media/gtbank.2a7e2449.svg";